/* unplugin-vue-components disabled */import script from "./admin.vue?vue&type=script&setup=true&lang=ts"
export * from "./admin.vue?vue&type=script&setup=true&lang=ts"

import "./admin.vue?vue&type=style&index=0&id=087b1892&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-087b1892"]])

export default __exports__